/*
 * BuildDocs пользовательский интерфейс version 0.1.0
 *
 * Copyright © 2021 ООО АДАПТ info@acfs.spb.ru
 * You may use, distribute and modify this code under the
 * terms of the ООО АДАПТ license
 */

import { useQuery } from 'react-query'

import { getTemplatesStamps, getTemplateStamp } from './filestore.stamp.service'

export function useStamp({ stampId }: { stampId: string }) {
  return useQuery({
    queryFn: () => getTemplateStamp(stampId),
    queryKey: ['stamps', 'byTemplateId', stampId],
  })
}

interface UseStampsQueryProps {
  page: number
  size: number
  projectId?: string
  assigneeTypes: Array<string>
}

export const useStampsQuery = ({
  page,
  size,
  projectId,
  assigneeTypes,
}: UseStampsQueryProps) => {
  return useQuery({
    queryKey: ['stamps', { page, size, projectId, assigneeTypes }],
    queryFn: () => getTemplatesStamps(page, size, projectId, assigneeTypes),
  })
}
